import React from 'react';
import { map, times } from 'lodash';
import { Card, Container } from 'react-bootstrap';
import OwlCarousel from 'react-owl-carousel';
import { useTranslation } from 'react-i18next';
import { renderToString } from 'react-dom/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

import '@components/Base/CustomOwlCarousel/style.scss';

const options = {
  loop: true,
  center: true,
  items: 3,
  margin: 0,
  autoplay: false,
  dots: true,
  autoplayTimeout: 8500,
  smartSpeed: 450,
  nav: true,
  navText: [
    renderToString(<FontAwesomeIcon icon={faChevronLeft} size="2x" />),
    renderToString(<FontAwesomeIcon icon={faChevronRight} size="2x" />),
  ],
  responsive: {
    0: {
      items: 1,
    },
    720: {
      items: 2,
    },
    992: {
      items: 3,
    },
  },
};

const EligibilitySection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-5 bg-light">
      <h2 className="text-center">{t('personalAccidentInsurancePage.eligibilitySection.title')}</h2>
      <p className="text-center text-secondary">{t('personalAccidentInsurancePage.eligibilitySection.subTitle')}</p>
      <Container>
        <OwlCarousel {...options} className="custom-owl-carousel">
          {map(times(7), (idx) => (
            <Card key={`eligibilityItem${idx}`} className="p-4 m-4 shadow-sm text-center" style={{ height: '200px' }}>
              <Card.Title>{t(`personalAccidentInsurancePage.eligibilitySection.item${idx + 1}.label`)}</Card.Title>
              <Card.Text>{t(`personalAccidentInsurancePage.eligibilitySection.item${idx + 1}.desc`)}</Card.Text>
            </Card>
          ))}
        </OwlCarousel>
      </Container>
    </section>
  );
};

export { EligibilitySection };
